import { computed } from 'vue';

const CLICK_EVENT = "item-click";
const KEY_CLICK_EVENT = "item-key-click";
const useItemClickHandler = ($listeners, emits) => {
  const onItemKeyClick = (item) => {
    emits(KEY_CLICK_EVENT, item);
  };
  const hasItemKeyClickListener = computed(
    () => $listeners !== void 0 && Object.prototype.hasOwnProperty.call($listeners, KEY_CLICK_EVENT)
  );
  const onItemClick = (item) => {
    emits(CLICK_EVENT, item);
  };
  const hasItemClickListener = computed(
    () => $listeners !== void 0 && Object.prototype.hasOwnProperty.call($listeners, CLICK_EVENT)
  );
  const itemClickHandlerAttributes = computed(() => {
    return {
      tabindex: hasItemClickListener.value ? 0 : void 0,
      role: hasItemClickListener.value ? "link" : void 0
    };
  });
  const itemClickHandlerEvents = (item) => {
    return {
      click: (e) => {
        e.preventDefault();
        onItemClick(item);
      },
      keyup: (e) => {
        if (e.key === "Enter") {
          onItemClick(item);
        }
      }
    };
  };
  const itemClickHandlerKeyEvents = (item) => {
    return {
      click: (e) => {
        e.preventDefault();
        onItemKeyClick(item);
      },
      keyup: (e) => {
        if (e.key === "Enter") {
          onItemKeyClick(item);
        }
      }
    };
  };
  return {
    onItemKeyClick,
    onItemClick,
    hasItemKeyClickListener,
    hasItemClickListener,
    itemClickHandlerAttributes,
    itemClickHandlerEvents,
    itemClickHandlerKeyEvents
  };
};

export { useItemClickHandler };
